import * as React from "react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";

export const ResultsSummary: React.FC<ContentEvaluationModel.ResultsSummaryProps> = ({ totalFindings }) => {
    const isSuccess = totalFindings === 0;

    return (
        <div style={{
            padding: "12px",
            backgroundColor: isSuccess ? "#f0f9ff" : "#fef7f0",
            borderRadius: "8px",
            border: `1px solid ${isSuccess ? "#3b82f6" : "#fbbf24"}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }}>
            <p style={{
                fontSize: "16px",
                fontWeight: "600",
                color: isSuccess ? "#1d4ed8" : "#d97706",
                margin: "0"
            }}>
                {totalFindings === 0
                    ? "✅ No findings - Content complies with all guidelines!"
                    : `⚠️ Detected ${totalFindings} finding${totalFindings > 1 ? "s" : ""}`
                }
            </p>
        </div>
    );
};
